namespace Areas.ContractorPay.Payment{
    "use strict";

    let contractScheduleValueId: number;
    let runQuery: boolean = false;

    export function getContractScheduleValueId() {
        return contractScheduleValueId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function onPaymentGridSelectionChanged(e: any) {

        //let rowData: any = e.selectedRowsData[0];

        //let rowForm: any = $("#PaymentForm").dxForm("instance");
        //rowForm.option("formData", rowData);


        let selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            runQuery = true;
            contractScheduleValueId = selectedRows[0].contractScheduleValueId;
            Areas.refreshGrid("PaymentDetailGrid");
        }
    }


    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    function goToSharePoint(sharePointLink: string) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId: number) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }


}